import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.applications', {
        url: '/applications',
        views: {
            '': 'userApplications',
            'header@user': 'userApplicationsHeader',
        },
        resolve: {applications,registeringApplications},
    });
}

/** @ngInject */
function applications(ApplicationService) {
    return ApplicationService.findAll().$promise;
}
/** @ngInject */
function registeringApplications(ApplicationService) {
    return ApplicationService.findAllToRegister().$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/applications.state.js